var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 32.0007L19.0003 0.333984L37.3337 32.0007H0.666992ZM5.47241 29.2227H32.5282L19.0003 5.8894L5.47241 29.2227ZM19.1162 27.084C19.5112 27.084 19.8406 26.9504 20.1045 26.6832C20.3684 26.4162 20.5003 26.0852 20.5003 25.6902C20.5003 25.2952 20.3667 24.9658 20.0995 24.7019C19.8325 24.438 19.5016 24.3061 19.1066 24.3061C18.7116 24.3061 18.3821 24.4397 18.1182 24.7069C17.8544 24.9741 17.7224 25.3051 17.7224 25.6998C17.7224 26.0948 17.856 26.4243 18.1232 26.6882C18.3905 26.952 18.7214 27.084 19.1162 27.084ZM17.7224 22.334H20.5003V13.334H17.7224V22.334Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3c0f21724ad1cc3907e4bcbcdf3570b4.svg";
export { ForwardRef as ReactComponent };